import { Component, OnInit, OnChanges, Input, SimpleChanges, ViewChild } from '@angular/core';
import { MatAccordion } from '@angular/material/expansion';
import { DataService } from 'app/shared/services/dataService';
import { CaseService } from '../../shared/services/caseService';


@Component({
  selector: 'app-alerts',
  templateUrl: './alerts.component.html',
  styleUrls: ['./alerts.component.css']
})
export class AlertsComponent implements OnInit, OnChanges {
  @Input() caseId: string;
  private alertsData: any =[];
  careAlert: Array<string> = [];
  overDose: Array<string> = [];
  priorVisits: Array<string> = [];
  careTeam: Array<string> = [];
  private loadingCount = 0;
  lookUpDuration = '6';
  @ViewChild(MatAccordion) accordion: MatAccordion;
  printLoading: boolean = false;

  constructor(private dataService: DataService, private caseService: CaseService) { }

  ngOnInit() {
   this.getAlertData();
  }

  ngOnChanges() {
   this.getAlertData();
  }


  runQuery() {
    this.getAlertData();
  }
  private getAlertData() {
    this.loadingCount ++;
    this.dataService.getAlertsData(this.caseId, this.lookUpDuration).then(val => {
      this.alertsData = val;
      this.parseResponse();
      this.loadingCount --;
    }).catch(() => { this.loadingCount --; });
  }
  parseResponse() {
    this.careAlert.length = 0;
    this.overDose.length = 0;
    this.priorVisits.length = 0;
    this.careTeam.length = 0;

    this.alertsData.forEach(obj => {
      if (obj.type.text == "Prior Visits") {
        this.priorVisits.push(obj.fullText)
      }
      if (obj.type.text == "Care Alerts") {
        this.careAlert.push(obj.fullText)
      }
      if (obj.type.text == "Overdose Notification") {
        this.overDose.push(obj.fullText)
      }
      if (obj.type.text == "Care Team") {
        this.careTeam.push(obj.fullText)
      }
    })
  }

  printModalContents() {
    var details = {
      caseId: this.caseId,
      priorVisits: this.priorVisits,
      careAlert: this.careAlert,
      overDose: this.overDose,
      careTeam: this.careTeam
    }
    this.printLoading = true;
    this.caseService.printAlertDetails(JSON.stringify(details)).then(pdfBlob => {
      const blobUrl = URL.createObjectURL(pdfBlob);
      const newTab = window.open(blobUrl, '_blank');
      newTab.onload = () => {
        newTab.print();
        URL.revokeObjectURL(blobUrl);
      };
      this.printLoading = false;
    }).catch(err => this.printLoading = false);
  }
}
